import React, {useState} from "react";

type Props = {
    onChange: (value: boolean) => void,
    value: boolean
}
export const RoundSlider = ({onChange, value}: Props) => {

    const [isChecked, setIsChecked] = useState(value);

    const toggleCheckbox = () => {
        try {
            onChange(!isChecked)
            setIsChecked(!isChecked);
        } catch (e) {
            setIsChecked(false)
        }
    };

    return (
        <div
            className={`w-12 h-6.5 flex items-center rounded-full p-1 cursor-pointer ${
                isChecked ? 'bg-melon-yellow' : 'bg-gray-300'
            }`}
            onClick={toggleCheckbox}
        >
            <div
                className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform ${
                    isChecked ? 'translate-x-5' : 'translate-x-0'
                }`}
            ></div>
        </div>
    );
};